import * as React from 'react';
import { Field } from 'uitk-react-form';
import { FlightsSortAndFilters } from '@shared-ui/retail-sort-and-filter-flights';

import { useSortAndFilterInput } from 'utility/hooks';
import { triggerSortSearchCall } from './usf-utils';
import { SortAndFiltersViewType } from 'types/search/sort-filter';
import { closeDialogs } from 'utility';
import { UniversalSortAndFiltersProps } from 'experiments/PWA_USF_FSR/UniversalSortAndFiltersProps';

export const UniversalSort = (props: UniversalSortAndFiltersProps) => {
  const { context, history, location, searchCriteriaStore } = props;
  const sortAndFilterInput = useSortAndFilterInput();
  const handleOnFieldChange = React.useCallback(
    (field: Field) => {
      closeDialogs({
        history,
        location,
        callback: () => triggerSortSearchCall(field, searchCriteriaStore, context, history, location)
      });
    },
    [searchCriteriaStore, context, history, location]
  );

  const handleCloseDialog = React.useCallback(() => {
    closeDialogs({
      history,
      location
    });
  }, [history, location]);

  if (!searchCriteriaStore.searchCriteria.journeyCriteria[0].departureDate.day) {
    return null;
  }

  return (
    <div>
      <FlightsSortAndFilters
        onFieldChange={handleOnFieldChange}
        view={SortAndFiltersViewType.SORT}
        inputs={sortAndFilterInput}
        onKeyPress={handleCloseDialog}
        onClick={handleCloseDialog}
      />
    </div>
  );
};
